/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchInvestmentRequestItem
 */
export interface BatchInvestmentRequestItem {
    /**
     * 
     * @type {string}
     * @memberof BatchInvestmentRequestItem
     */
    portfolioGuid: string;
    /**
     * 
     * @type {string}
     * @memberof BatchInvestmentRequestItem
     */
    description: string;
}

/**
 * Check if a given object implements the BatchInvestmentRequestItem interface.
 */
export function instanceOfBatchInvestmentRequestItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "portfolioGuid" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

export function BatchInvestmentRequestItemFromJSON(json: any): BatchInvestmentRequestItem {
    return BatchInvestmentRequestItemFromJSONTyped(json, false);
}

export function BatchInvestmentRequestItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchInvestmentRequestItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'portfolioGuid': json['portfolio_guid'],
        'description': json['description'],
    };
}

export function BatchInvestmentRequestItemToJSON(value?: BatchInvestmentRequestItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'portfolio_guid': value.portfolioGuid,
        'description': value.description,
    };
}

